import React from "react";
import { useNavigate } from "react-router-dom";
import PostComposer from "../components/PostComposer";

export default function CreatePost() {

  const navigate = useNavigate();

  return (
    <div className="page">

      <h2>Create Something</h2>

      <div
        style={{
          display: "flex",
          gap: 12,
          marginBottom: 20
        }}
      >
    
      </div>

      <h3>Create Post</h3>

      <PostComposer />

    </div>
  );

}